var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "px-6 py-6", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-stepper",
                {
                  staticClass: "bg-transparent overflow-visible w-100 mx-auto",
                  attrs: { "alt-labels": "", elevation: "0" },
                  model: {
                    value: _vm.e1,
                    callback: function ($$v) {
                      _vm.e1 = $$v
                    },
                    expression: "e1",
                  },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "mx-auto mt-3", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-stepper-header",
                            { staticClass: "shadow-0" },
                            [
                              _c(
                                "v-stepper-step",
                                { attrs: { step: "1", color: "#0A3542" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-secondary font-weight-normal",
                                    },
                                    [_vm._v("Project")]
                                  ),
                                ]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                { attrs: { step: "2", color: "#0A3542" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-secondary font-weight-normal",
                                    },
                                    [_vm._v("Purpose")]
                                  ),
                                ]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                { attrs: { step: "3", color: "#0A3542" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-secondary font-weight-normal",
                                    },
                                    [_vm._v("Brands")]
                                  ),
                                ]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                { attrs: { step: "4", color: "#0A3542" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-secondary font-weight-normal",
                                    },
                                    [_vm._v("Competitors")]
                                  ),
                                ]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                { attrs: { step: "5", color: "#0A3542" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-secondary font-weight-normal",
                                    },
                                    [_vm._v("Goals")]
                                  ),
                                ]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                { attrs: { step: "6", color: "#0A3542" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-secondary font-weight-normal",
                                    },
                                    [_vm._v("Seeds")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: `/#/pages/research/client/${this.$route.params.clientId}/`,
                          },
                        },
                        [_c("v-btn", [_vm._v("Back to client")])],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mx-auto",
                          attrs: { lg: "8", cols: "12" },
                        },
                        [
                          _c(
                            "v-stepper-items",
                            {
                              staticClass:
                                "border-radius-xl overflow-hidden shadow-lg mt-5 mb-9",
                            },
                            [
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "1" },
                                },
                                [
                                  _c("v-card", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "10" },
                                              },
                                              [
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "text-h4 font-weight-normal mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " New Keyword Research Project "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          { staticClass: "mt-2" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "5" } },
                                              [
                                                _c(
                                                  "v-container",
                                                  { attrs: { fluid: "" } },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "text-sm font-weight-bolder ms-3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Project name: "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "font-size-input placeholder-lighter border border-radius-md mt-2 mb-4",
                                                      attrs: {
                                                        rules: [
                                                          (v) =>
                                                            !!v ||
                                                            "Project name is required",
                                                        ],
                                                        "hide-details": "",
                                                        outlined: "",
                                                        color: "rgba(0,0,0,.6)",
                                                        light: "",
                                                        placeholder: "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.projectFormData
                                                            .projectName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.projectFormData,
                                                            "projectName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "projectFormData.projectName",
                                                      },
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "text-sm font-weight-bolder ms-3",
                                                      },
                                                      [_vm._v(" Type: ")]
                                                    ),
                                                    _c(
                                                      "v-radio-group",
                                                      {
                                                        staticClass:
                                                          "ms-3 mt-1",
                                                        attrs: {
                                                          rules: [
                                                            (v) =>
                                                              !!v ||
                                                              "Project type is required",
                                                          ],
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.projectFormData
                                                              .type,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.projectFormData,
                                                              "type",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "projectFormData.type",
                                                        },
                                                      },
                                                      [
                                                        _c("v-radio", {
                                                          attrs: {
                                                            label: "Website",
                                                            value: "website",
                                                          },
                                                        }),
                                                        _c("v-radio", {
                                                          attrs: {
                                                            label:
                                                              "Market Research",
                                                            value:
                                                              "market-research",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c("label", [
                                                      _vm._v(
                                                        " Google Search Console site URL: "
                                                      ),
                                                    ]),
                                                    _c("v-select", {
                                                      staticClass:
                                                        "input-style font-size-input text-light-input placeholder-light border-radius-md select-style mt-3 mb-0",
                                                      attrs: {
                                                        items: _vm.siteList,
                                                        rules: [
                                                          (v) =>
                                                            !!v ||
                                                            "GSC site URL is required",
                                                        ],
                                                        disabled:
                                                          _vm.siteList
                                                            .length === 0 ||
                                                          _vm.siteListLoading,
                                                        loading:
                                                          _vm.siteListLoading,
                                                        placeholder:
                                                          _vm.siteListLoading
                                                            ? "Loading sites..."
                                                            : "Select a site",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.projectFormData
                                                            .gsc_site_url,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.projectFormData,
                                                            "gsc_site_url",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "projectFormData.gsc_site_url",
                                                      },
                                                    }),
                                                    _vm.siteList.length === 0 &&
                                                    !_vm.siteListLoading
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass: "mt-2",
                                                          },
                                                          [
                                                            _c(
                                                              "v-alert",
                                                              {
                                                                staticClass:
                                                                  "text-xs",
                                                                attrs: {
                                                                  type: "warning",
                                                                  dense: "",
                                                                  text: "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1",
                                                                    attrs: {
                                                                      small: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-alert-circle"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  " Google Search Console sites could not be loaded. Please check your authentication. "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "5" } },
                                              [
                                                _c(
                                                  "v-container",
                                                  { attrs: { fluid: "" } },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "text-sm font-weight-bolder ms-3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Subject domain name: "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "font-size-input placeholder-lighter border border-radius-md mt-2 mb-4",
                                                      attrs: {
                                                        rules: [
                                                          (v) =>
                                                            !!v ||
                                                            "Domain name is required",
                                                        ],
                                                        "hide-details": "",
                                                        outlined: "",
                                                        color: "rgba(0,0,0,.6)",
                                                        light: "",
                                                        placeholder:
                                                          "e.g., https://www.domain.com",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.projectFormData
                                                            .subjectDomain,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.projectFormData,
                                                            "subjectDomain",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "projectFormData.subjectDomain",
                                                      },
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "text-sm font-weight-bolder ms-3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Geographic area of audience: "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "font-size-input placeholder-lighter border border-radius-md mt-2 mb-4",
                                                      attrs: {
                                                        rules: [
                                                          (v) =>
                                                            !!v ||
                                                            "Geographic area is required",
                                                        ],
                                                        "hide-details": "",
                                                        outlined: "",
                                                        color: "rgba(0,0,0,.6)",
                                                        light: "",
                                                        placeholder: "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.projectFormData
                                                            .geographicArea,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.projectFormData,
                                                            "geographicArea",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "projectFormData.geographicArea",
                                                      },
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "text-sm font-weight-bolder ms-3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Industry or market selector: "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "input-style font-size-input text-light-input placeholder-light border-radius-md mt-3 mb-0",
                                                      attrs: {
                                                        commentout:
                                                          ":rules=[v => !!v || 'Industry is required']",
                                                        outlined: "",
                                                        "single-line": "",
                                                        height: "38",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.projectFormData
                                                            .industryOrMarket,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.projectFormData,
                                                            "industryOrMarket",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "projectFormData.industryOrMarket",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "text-end" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs btn-default bg-gradient-default py-5 px-6 mt-2 mb-2 me-2",
                                            attrs: {
                                              disabled: !_vm.step1Valid,
                                              ripple: false,
                                              elevation: 0,
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 2
                                              },
                                            },
                                          },
                                          [_vm._v(" Next ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "2" },
                                },
                                [
                                  _c("v-card", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "10" },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "float-left my-1 mr-2",
                                                    attrs: {
                                                      large: "",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " mdi-information-outline "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "text-h4 font-weight-normal mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " What's the purpose of the Website or Application? "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-body text-sm",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Be as detailed as you can. If you are struggling for an expansive description, type a brief one and click 'Expand with AI' "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-textarea", {
                                                  attrs: {
                                                    rules: [
                                                      (v) =>
                                                        !!v ||
                                                        "Purpose is required",
                                                    ],
                                                    solo: "",
                                                    placeholder:
                                                      "Purpose (if you're doing market research, you can leave this blank)",
                                                    value: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.projectFormData
                                                        .purpose,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.projectFormData,
                                                        "purpose",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "projectFormData.purpose",
                                                  },
                                                }),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold text-xs text-dark btn-light py-5 px-6 mt-6 mb-2 ms-2",
                                                    attrs: {
                                                      ripple: false,
                                                      elevation: 0,
                                                    },
                                                  },
                                                  [_vm._v(" Expand with AI ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex mt-10" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs text-dark btn-light bg-gradient-light py-5 px-6 mt-6 mb-2 ms-2",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 1
                                              },
                                            },
                                          },
                                          [_vm._v(" Prev ")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs btn-default bg-gradient-default py-5 px-6 mt-6 mb-2 me-2 ms-auto",
                                            attrs: {
                                              disabled: !_vm.step2Valid,
                                              ripple: false,
                                              elevation: 0,
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 3
                                              },
                                            },
                                          },
                                          [_vm._v(" Next ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "3" },
                                },
                                [
                                  _c("v-card", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "10" },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "float-left my-1 mr-2",
                                                    attrs: {
                                                      large: "",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " mdi-information-outline "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "text-h4 font-weight-normal mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " What are your brand names? "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-body text-sm",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Be as comprehensive as you can if the name is used as a trademark, even for a specific product. "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-textarea", {
                                                  attrs: {
                                                    rules: [
                                                      (v) =>
                                                        !!v ||
                                                        "Brand name is required",
                                                    ],
                                                    solo: "",
                                                    placeholder: "",
                                                    value: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.projectFormData
                                                        .brandNames,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.projectFormData,
                                                        "brandNames",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "projectFormData.brandNames",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex mt-10" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs text-dark btn-light bg-gradient-light py-5 px-6 mt-6 mb-2 ms-2",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 2
                                              },
                                            },
                                          },
                                          [_vm._v(" Prev ")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs btn-default bg-gradient-default py-5 px-6 mt-6 mb-2 me-2 ms-auto",
                                            attrs: {
                                              disabled: !_vm.step3Valid,
                                              ripple: false,
                                              elevation: 0,
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 4
                                              },
                                            },
                                          },
                                          [_vm._v(" Next ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "4" },
                                },
                                [
                                  _c("v-card", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "10" },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "float-left my-1 mr-2",
                                                    attrs: {
                                                      large: "",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " mdi-information-outline "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "text-h4 font-weight-normal mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " What are the brand names you compete against? "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-body text-sm",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Be as comprehensive as you can if the name is used as a trademark, even for a specific product. "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-textarea", {
                                                  attrs: {
                                                    rules: [
                                                      (v) =>
                                                        !!v ||
                                                        "Competitor brand(s) required",
                                                    ],
                                                    solo: "",
                                                    placeholder:
                                                      "Be as comprehensive as you can be, but you can always edit this selection later, so don't sweat it too much.",
                                                    value: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.projectFormData
                                                        .competitorBrandNames,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.projectFormData,
                                                        "competitorBrandNames",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "projectFormData.competitorBrandNames",
                                                  },
                                                }),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold text-xs text-dark btn-light py-5 px-6 mt-6 mb-2 ms-2",
                                                    attrs: {
                                                      ripple: false,
                                                      elevation: 0,
                                                    },
                                                  },
                                                  [_vm._v(" Expand with AI ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex mt-10" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs text-dark btn-light bg-gradient-light py-5 px-6 mt-6 mb-2 ms-2",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 3
                                              },
                                            },
                                          },
                                          [_vm._v(" Prev ")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs btn-default bg-gradient-default py-5 px-6 mt-6 mb-2 me-2 ms-auto",
                                            attrs: {
                                              disabled: !_vm.step4Valid,
                                              ripple: false,
                                              elevation: 0,
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 5
                                              },
                                            },
                                          },
                                          [_vm._v(" Next ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "5" },
                                },
                                [
                                  _c("v-card", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "10" },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "float-left my-1 mr-2",
                                                    attrs: {
                                                      large: "",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " mdi-information-outline "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "text-h4 font-weight-normal mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " What's the Conversion Goal? "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-body text-sm",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " What action do you want your ideal customer to take? "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-textarea", {
                                                  attrs: {
                                                    rules: [
                                                      (v) =>
                                                        !!v ||
                                                        "Conversion goal(s) required",
                                                    ],
                                                    solo: "",
                                                    placeholder:
                                                      "What I want customers to do.  Here are some examples...\n˖  Request information with a form\n˖  Make a purchase\n˖  Call our office",
                                                    value: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.projectFormData
                                                        .conversions,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.projectFormData,
                                                        "conversions",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "projectFormData.conversions",
                                                  },
                                                }),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold text-xs text-dark btn-light py-5 px-6 mt-6 mb-2 ms-2",
                                                    attrs: {
                                                      ripple: false,
                                                      elevation: 0,
                                                    },
                                                  },
                                                  [_vm._v(" Give Me Ideas * ")]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-body text-xs ml-3 font-italic",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " * Ideas are generated by AI "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex mt-10" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs text-dark btn-light bg-gradient-light py-5 px-6 mt-6 mb-2 ms-2",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 4
                                              },
                                            },
                                          },
                                          [_vm._v(" Prev ")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs btn-default bg-gradient-default py-5 px-6 mt-6 mb-2 me-2 ms-auto",
                                            attrs: {
                                              disabled: !_vm.step5Valid,
                                              ripple: false,
                                              elevation: 0,
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 6
                                              },
                                            },
                                          },
                                          [_vm._v(" Next ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "6" },
                                },
                                [
                                  _c("v-card", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "10" },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "float-left my-1 mr-2",
                                                    attrs: {
                                                      large: "",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " mdi-information-outline "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "text-h4 font-weight-normal mb-2",
                                                  },
                                                  [_vm._v(" Seed Keywords ")]
                                                ),
                                                _c(
                                                  "p",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " Select keywords that will be used as seeds to generate a larger list of keywords that could be useful to rank for. It's recommended to have at least 10 seed keywords, and no more than 15. "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " If you wish, we can generate these for you automatically based on the information provided so far. "
                                                    ),
                                                  ]
                                                ),
                                                _c("seeds-get", {
                                                  attrs: {
                                                    seeds:
                                                      _vm.projectFormData.seeds,
                                                    promptData:
                                                      _vm.seedPromptData,
                                                  },
                                                  on: {
                                                    seedUpdate: function (
                                                      $event
                                                    ) {
                                                      _vm.projectFormData.seeds =
                                                        $event
                                                    },
                                                  },
                                                }),
                                                _c("v-checkbox", {
                                                  staticClass: "mt-4",
                                                  attrs: {
                                                    label:
                                                      "Attempt to fetch SEMRUSH data",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm
                                                        .projectCreationSettings
                                                        .get_semrush_data,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.projectCreationSettings,
                                                        "get_semrush_data",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "projectCreationSettings.get_semrush_data",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex mt-10" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs text-dark btn-light bg-gradient-light py-5 px-6 mt-6 mb-2 ms-2",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 5
                                              },
                                            },
                                          },
                                          [_vm._v(" Prev ")]
                                        ),
                                        _c(
                                          "v-container",
                                          {
                                            staticClass:
                                              "d-flex justify-end align-center mt-2 mb-2 me-0 py-5 px-6",
                                          },
                                          [
                                            _vm.projectLoading
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mt-auto" },
                                                  [
                                                    _c("v-progress-circular", {
                                                      staticClass: "px-8",
                                                      attrs: {
                                                        indeterminate: "",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      { staticClass: "pe-16" },
                                                      [
                                                        _vm._v(
                                                          "Creating project..."
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "font-weight-bold text-xs btn-default bg-gradient-default",
                                                attrs: {
                                                  disabled: !_vm.step6Valid,
                                                  ripple: false,
                                                  elevation: 0,
                                                  color: "primary",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.postProject()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " Finish & create project "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }